module.exports = __webpack_public_path__ + "lc.0a7e9442425b8d4b1c90.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/lc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/lc.svg
// module chunks = styles